export const countFractionDigits = (number = 0) => {
    const stringRepresentation = number.toString();
    if (stringRepresentation.indexOf('e-') > 0) {
        // It's too small for a normal string representation, e.g. 1e-7 instead of 0.00000001
        return parseInt(stringRepresentation.split('e-')[1], 10);
    }
    const fractionDigits = stringRepresentation.split('.')[1];
    return fractionDigits ? fractionDigits.length : 0;
};
